import type { GridState } from '@ag-grid-community/core';

const ALWAYS_VISIBLE_COLUMN_IDS = new Set([
    'ag-Grid-ControlsColumn',
    'expandable',
]);

interface UseGridColumnState {
    saveColumnsState: (state: GridState) => void;
    getColumnsState: () => GridState;
}

function sanitizeGridState({
    rowSelection: _rowSelection,
    columnVisibility,
    ...state
}: GridState): GridState {
    const hiddenColIds = columnVisibility?.hiddenColIds.filter(
        (colId) => !ALWAYS_VISIBLE_COLUMN_IDS.has(colId),
    );

    if (!hiddenColIds?.length) {
        return state;
    }

    return {
        ...state,
        columnVisibility: { hiddenColIds },
    };
}

export function useGridColumnState(id: string): UseGridColumnState {
    return {
        saveColumnsState: (state: GridState) => {
            window.sessionStorage.setItem(
                id,
                JSON.stringify(sanitizeGridState(state)),
            );
        },
        getColumnsState: (): GridState => {
            try {
                const storedState = window.sessionStorage.getItem(id);
                if (!storedState) {
                    return {};
                }
                return sanitizeGridState(JSON.parse(storedState) as GridState);
            } catch (_) {
                return {};
            }
        },
    };
}
